"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import { PaymentController } from "@/service/newProdect";
import PaymentNewOptionsMoreDialog from "@/views/payItems/components/PaymentNewOptionsMoreDialog.vue";
let PaymentNewComputerConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.showComputer = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  changeShowFlag() {
    var _a;
    if (((_a = this._options.selected.categorys) == null ? void 0 : _a.marks.is("SHOW_CONFIG")) === true) {
      this.showComputer = ["computer"];
    } else {
      this.showComputer = [];
    }
  }
  changeViews() {
    this.$emit("changeOptions");
  }
  moreOperations() {
    this._options_dialog.open();
  }
};
__decorateClass([
  Ref("more-operation-dialog")
], PaymentNewComputerConfig.prototype, "_options_dialog", 2);
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewComputerConfig.prototype, "_options", 2);
PaymentNewComputerConfig = __decorateClass([
  Component({
    components: { PaymentNewOptionsMoreDialog }
  })
], PaymentNewComputerConfig);
export {
  PaymentNewComputerConfig as default
};
